@if (loading) {
  <hls-loading-indicator></hls-loading-indicator>
}
@if (!loading && iconLeft) {
  <hls-icon [icon]="iconLeft"></hls-icon>
}
<span>
  @if (!isLoading) {
    <slot></slot>
  }
  @if (isLoading) {
    <span [innerText]="loading"></span>
  }
</span>
@if (!isLoading && iconRight) {
  <hls-icon [icon]="iconRight"></hls-icon>
}
